// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767px) {
  ::ng-deep .modal-dialog.u2111-select-organization-modal {
    max-width: 99%;
  }
}
@media (min-width: 768px) {
  ::ng-deep .modal-dialog.u2111-select-organization-modal {
    max-width: 600px;
  }
}
@media (min-width: 992px) {
  ::ng-deep .modal-dialog.u2111-select-organization-modal {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  ::ng-deep .modal-dialog.u2111-select-organization-modal {
    max-width: 1000px;
  }
}
.modal-footer {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/U2011_login/U2011_organizationselection-modal/U2011_organizationselection-modal.component.scss"],"names":[],"mappings":"AAKA;EACI;IACI,cAAA;EAJN;AACF;AAOA;EACI;IACI,gBAAA;EALN;AACF;AAQA;EACI;IACI,gBAAA;EANN;AACF;AASA;EACI;IACI,iBAAA;EAPN;AACF;AAUA;EACI,kBAAA;AARJ","sourcesContent":["\n@import \"../../U2000_style/U2000_style-mixins\";\n@import \"../../U2000_style/U2000_style-variables\";\n\n\n@media (max-width: $screen-xs-top) {\n    ::ng-deep .modal-dialog.u2111-select-organization-modal {\n        max-width: 99%;\n    }\n}\n\n@media (min-width: $screen-sm-bottom) {\n    ::ng-deep .modal-dialog.u2111-select-organization-modal {\n        max-width: 600px;\n    }\n}\n\n@media (min-width: $screen-md-bottom) {\n    ::ng-deep .modal-dialog.u2111-select-organization-modal {\n        max-width: 800px;\n    }\n}\n\n@media (min-width: $screen-lg-bottom) {\n    ::ng-deep .modal-dialog.u2111-select-organization-modal {\n        max-width: 1000px;\n    }\n}\n\n.modal-footer {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
